// Colour stops shared by the 2D map and the 3D viewer (mirrors render.py).
export const TEMPERATURE_STOPS = Object.freeze([
  [0, [58, 40, 168]], [0.13, [36, 92, 226]], [0.27, [14, 152, 242]], [0.4, [12, 204, 222]], [0.53, [34, 208, 136]],
  [0.66, [150, 222, 48]], [0.78, [252, 218, 36]], [0.89, [252, 140, 28]], [1, [228, 40, 52]]
]);
export const CURRENT_SPEED_STOPS = Object.freeze([
  [0, [22, 58, 128]], [0.22, [40, 92, 178]], [0.45, [98, 70, 186]], [0.68, [172, 60, 170]], [0.86, [232, 86, 118]], [1, [252, 158, 72]]
]);

// Bathymetry profiles use the same shared depth scale across all five lakes.
// The ocean ramp preserves the existing 3D colours; lake-floor warms the
// shallow shelves before moving through aqua into deep blue.
export const BED_PALETTES = Object.freeze({
  ocean: Object.freeze([
    [0, [179, 235, 209]], [0.25, [89, 189, 199]], [0.5, [48, 128, 179]],
    [0.75, [36, 79, 143]], [1, [26, 38, 94]]
  ]),
  "lake-floor": Object.freeze([
    [0, [220, 231, 193]], [0.055, [244, 207, 100]], [0.115, [190, 208, 155]],
    [0.25, [106, 183, 172]], [0.42, [83, 188, 218]], [0.6, [43, 127, 203]],
    [0.8, [27, 67, 145]], [1, [10, 20, 55]]
  ])
});
